export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";